import { object, string } from 'prop-types'
import Uploader from '.'

const renderPromptText = (text) => <p>{text}</p>

const AreaUploader = (props) => (
  <Uploader
    {...props}
    promptText={renderPromptText(props.promptText)}
    type="area"
  />
)

AreaUploader.propTypes = {
  iconName: string,
  iconStyles: object,
  promptText: string,
}

AreaUploader.defaultProps = {
  iconName: 'upload-cloud-lg',
  iconStyles: { height: 25, width: 40 },
  promptText: 'Drop a file from your desktop or click to browse.',
}

export default AreaUploader
